import { RoleDirectory } from './types';

export interface KeyRoles { key: string; roleNames: string[] }

/**
 * Role NAMES (never people) in the user's own institution that hold any of the keys.
 * Uses the member-level help endpoint (names only, own institution). Successful answers are cached per
 * institution + key set; a FAILED call is never cached, so a transient error does not hide roles for the
 * rest of the session. On failure the card says "ask your administrator".
 */
export function createRoleDirectory(
    getInstitutionId: () => string | null,
    rolesWithKeys: (institutionId: string, keys: string[]) => Promise<KeyRoles[]>,
): RoleDirectory {
    const cache = new Map<string, Promise<KeyRoles[]>>();
    return {
        async rolesHolding(keys: string[]): Promise<string[]> {
            const inst = getInstitutionId();
            if (!inst || keys.length === 0) return [];
            const sorted = Array.from(new Set(keys)).sort();
            const id = `${inst}|${sorted.join(',')}`;
            let p = cache.get(id);
            if (!p) {
                p = rolesWithKeys(inst, sorted);
                cache.set(id, p);
                p.catch(() => { if (cache.get(id) === p) cache.delete(id); });
            }
            try {
                const rows = await p;
                return Array.from(new Set(rows.flatMap(r => r.roleNames)));
            } catch {
                return [];
            }
        },
    };
}
